// Pure geometry helpers of the maps, without Leaflet so they can be unit tested

export interface Point {
    lat: number
    lng: number
}

/**
 * Whether the point lies inside the polygon (ray casting, the polygon is closed implicitly). Treats lat/lng as flat
 * coordinates, which is precise enough for an area drawn on the screen.
 */
export function pointInPolygon(point: Point, polygon: Point[]) {
    let inside = false

    for (let i = 0, j = polygon.length - 1; i < polygon.length; j = i++) {
        const a = polygon[i]
        const b = polygon[j]

        if ((a.lat > point.lat) !== (b.lat > point.lat) && point.lng < (b.lng - a.lng) * (point.lat - a.lat) / (b.lat - a.lat) + a.lng) {
            inside = !inside
        }
    }

    return inside
}

/** Whether the event comes from a field the user types in, where Shift or Ctrl is part of typing and no map shortcut */
export function isTypingTarget(target: EventTarget | null) {
    const element = target as HTMLElement | null

    if (!element?.tagName) {
        return false
    }

    return ['INPUT', 'TEXTAREA', 'SELECT'].includes(element.tagName) || !!element.isContentEditable
}

/** The position if both coordinates are numbers, otherwise null (a position that wasn't geocoded) */
export function validPosition(position?: Partial<Point> | null): Point | null {
    return Number.isFinite(position?.lat) && Number.isFinite(position?.lng) ? {lat: position.lat, lng: position.lng} : null
}

/** Whether both are the same position, or both missing */
export function samePosition(a?: Partial<Point> | null, b?: Partial<Point> | null) {
    const pointA = validPosition(a)
    const pointB = validPosition(b)

    return pointA === pointB || (!!pointA && !!pointB && pointA.lat === pointB.lat && pointA.lng === pointB.lng)
}
